import { Tag, Typography } from "antd";
import IntlMessages from "../../../@richbeauty/utility/IntlMessages";
import {
  CUSTOMER_LEAD_STATUS,
  TABLE_ACTION_COLUMN_KEY,
  UserActionColumns,
} from "shared/constants/AppConst";
import moment from "moment";
import PhoneNumberItem from "@richbeauty/core/AppViewItems/PhoneNumberItem";
import CustomerLeadColumnActionOption from "./CustomerLeadColumnActionOption";
// import LeadColumnActionOption from "./LeadColumnActionOption";

const useGetCustomerLeadColumn = () => {
  return [
    {
      title: <IntlMessages id="app.customerLeads.firstName" />,
      dataIndex: "firstName",
      key: "firstName",
      width: 120,
    },
    {
      title: <IntlMessages id="app.customerLeads.lastName" />,
      dataIndex: "lastName",
      key: "lastName",
      width: 120,
    },
    {
      title: <IntlMessages id="app.customerLeads.phone" />,
      dataIndex: "phoneNumber",
      key: "phoneNumber",
      width: 140,
      render: (phone) => <PhoneNumberItem value={phone} />,
    },
    {
      title: <IntlMessages id="app.customerLeads.email" />,
      dataIndex: "email",
      key: "email",
      width: 180,
      render: (email) => (
        <Typography.Text style={{ color: "#1677ff" }}>
          {email}
        </Typography.Text>
      ),
    },
    {
      title: <IntlMessages id="app.customerLeads.dob" />,
      dataIndex: "dob",
      key: "dob",
      width: 120,
      render: (dob) => (dob ? moment(dob).format("DD/MM/YYYY") : ""),
    },
    {
      title: <IntlMessages id="app.customerLeads.gender" />,
      dataIndex: "gender",
      key: "gender",
      width: 100,
      render: (gender) => {
        if (gender === 1) return <Tag color="blue">{<IntlMessages id="app.customerLeads.gender.male" />}</Tag>;
        if (gender === 2) return <Tag color="magenta">{<IntlMessages id="app.customerLeads.gender.female" />}</Tag>;
        return <Tag color="default">{<IntlMessages id="app.customerLeads.gender.other" />}</Tag>;
      },
    },
    {
      title: <IntlMessages id="app.customerLeads.leadStatus" />,
      dataIndex: "status",
      key: "status",
      width: 150,
      render: (status) => {
        const targetColor = CUSTOMER_LEAD_STATUS.find(
          (item) => item.value === status
        )?.color;
        return <Tag color={targetColor}>{status}</Tag>;
      },
    },
    {
      title: <IntlMessages id="app.customerLeads.address" />,
      dataIndex: "address",
      key: "address",
      width: 200,
    },
    {
      title: <IntlMessages id="app.customerLeads.city" />,
      dataIndex: "city",
      key: "city",
      width: 120,
    },
    {
      title: <IntlMessages id="app.customerLeads.state" />,
      dataIndex: "state",
      key: "state",
      width: 100,
    },
    {
      title: <IntlMessages id="app.customerLeads.zipcode" />,
      dataIndex: "zipCode",
      key: "zipCode",
      width: 100,
    },
    ...UserActionColumns,
    {
      key: TABLE_ACTION_COLUMN_KEY,
      fixed: "right",
      title: <IntlMessages id="common.action" />,
      render: (_, record) => (
        <CustomerLeadColumnActionOption
          id={record?.id}
          campaignId={record?.seoCampaignId}
          status={record?.status}
          leadData={record}
        />
      ),
    },
  ];
};

export default useGetCustomerLeadColumn;
